import axios from '_u/axios'

// 工单列表
export const mWorkOrderList = (body) => {
    return axios.post('/api/workorder/order/listOfH5', body)
}

// 工单详情
export const mWorkOrderDetail = (body) => {
    if (typeof body === 'string') {
        body = { id: body }
    }
    return axios.post('/api/workorder/order/detailOfH5', body)
}

// 提交工单
export const mWorkOrderSubmit = (body) => {
    return axios.post('/api/workorder/order/submitOfH5', body)
}

// 取消工单
export const mWorkOrderCancel = (body) => {
    if (typeof body === 'string') {
        body = { id: body }
    }
    return axios.post('/api/workorder/order/cancelOfCus', body)
}


/*
    pc端
 */

// 工单列表
export const orderListOfPc = (body) => {
    return axios.post('/api/workorder/order/list',body)
}

// 工单详情
export const orderViewOfPc = (body) =>{
    return axios.post('/api/workorder/order/view',body)
}
